<button matRipple (click)="createCheckoutSession()" class="button" [disabled]="!SelectedMediaItem.url" [title]="buttonTitle">
    {{ 'page.detail.buttons.title_buy' | translate }}
</button>
